import { DeliveryWindowType } from './delivery-window-type.dto';

export interface ReferencedProduct {
  productId: string;
  masterProductId: string;
  productClassId: ProductTypeString;
  title: string;
  attributes: Attributes;
  baseImageUrl: string;
  categories: string[];
  productCompositionPartReferences: ProductCompositionPartReference[];
  accountData: ProductAccountData;
  brand: Brand;
}

export interface ProductCompositionPartReference {
  amount: number;
  product: ProductReference;
}

export interface ProductReference {
  productId: string;
  brandId: string;
}

export interface ExtendedReferencedProduct extends ReferencedProduct {
  masterProduct: ReferencedProduct & {
    masterProduct: ReferencedProduct;
  };
}

export interface Brand {
  brandId: string;
  name: string;
}

export interface ProductCompositionPart {
  amount: number;
  product: ExtendedReferencedProduct;
}

export interface BaseImageUrls {
  [index: string]: string;
}

export type Attributes = {
  [key: string]: string[];
};

export type ProductsMap = {
  [productId: string]: ReferencedProduct;
};

export enum ProductType {
  Material,
  Prepack,
  Size,
  Article,
}

export enum ProductTypeString {
  Material = 'material',
  Prepack = 'prepack',
  Size = 'size',
  Article = 'article',
}

export interface ProductAccountData {
  deliveryWindowType: DeliveryWindowType;
}
